import React from 'react';

import {
  infinityDetails,
  infinityCheckListDetails
} from '../../../Widgets/SetPlan/ChecklistsAndContent/content';

import PlanDetails from '.';

interface Props {
  onBackClick: () => void;
  onSelectPlan: () => void;
}

const InfinityPlanDetails = (props: Props) => {
  return (
    <PlanDetails
      heading="Greenlight Infinity"
      subheading="Best for families who want investing, our highest rewards, and safety tools."
      tools={infinityDetails}
      perks={infinityCheckListDetails}
      buttonText="Select Greenlight Infinity"
      onBackClick={props.onBackClick}
      onSelectPlan={props.onSelectPlan}
      footer={
        <>
          <p>
            <sup>1</sup>See Greenlight&apos;s Terms of Service for details on
            earnings limits and how to qualify. Subject to change at any time.
          </p>
          <p>
            <sup>2</sup>Cell phone and purchase protection provided by Virginia
            Surety Company Inc. Cell phone protection is not available to
            residents of New York.
          </p>
        </>
      }
    />
  );
};

export default InfinityPlanDetails;
